<template>
  <div class="form-main">
    <!-- 意见类型 -->
    <div class="borderTop">
      <van-field
        v-model="fieldValue"
        is-link
        readonly
        :label="$t('opinionType')"
        @click="typeShow = true"
      />
    </div>
    <!-- 意见类型问题 -->
    <div class="type-problem borderTop" v-if="fieldValue != '其他'">
      <div class="item-main">
        <van-checkbox-group v-model="checked" @change="changeChecked">
          <div class="heatel-item" v-for="item in abnormalList" :key="item.id">
            <van-checkbox
              shape="square"
              checked-color="#07C160"
              :name="item.id"
            ></van-checkbox>
            <div class="item-text">{{ item.name }}</div>
          </div>
        </van-checkbox-group>
      </div>
    </div>
    <!-- 档口/分店 -->
    <div class="borderTop">
      <van-field
        v-model="branchValue"
        is-link
        required
        readonly
        :label="$t('branchLabel')"
        @click="branchShow = true"
      />
    </div>
    <!-- 问题描述 -->
    <div class="borderTop">
      <van-field
        v-model="problemVal"
        rows="5"
        autosize
        :label="$t('problemLabel')"
        type="textarea"
        :placeholder="$t('problemPlaceholder')"
      />
    </div>
    <!-- 上传图片 -->
    <div class="borderTop uploadImg">
      <div class="title">{{ $t('uploadPic') }}</div>
      <div class="img-main">
        <van-uploader
          v-model="fileList"
          multiple
          :after-read="afterRead"
          :before-delete="deleteFile"
          capture="camera"
        />
        <!-- capture="['camera','album']" -->
      </div>
    </div>
    <!-- 手机号 -->
    <!-- <div class="borderTop">
      <van-field
        v-model="phoneVal"
        type="number"
        label="手机号"
        placeholder="请输入手机号"
      />
    </div> -->
    <!-- 学号工号 -->
    <!-- <div class="borderTop">
      <van-field
        v-model="studentId"
        label="学号/工号"
        placeholder="请输入学号或工号"
      />
    </div> -->
    <!-- 提交 -->
    <div class="submit" @click="handleSubmitFeed">{{ $t('submitBtn') }}</div>

    <!-- 意见类型弹窗 -->
    <van-popup v-model="typeShow" round position="bottom">
      <van-picker
        :title="$t('opinionType')"
        show-toolbar
        :confirm-button-text="$t('confirm')"
        :cancel-button-text="$t('orderCancel')"
        :columns="optionsType"
        @confirm="onConfirm"
        @cancel="onCancel"
        @change="handleChangeType"
      />
    </van-popup>
    <!-- 档口/分店弹窗 -->
    <van-popup v-model="branchShow" round position="bottom">
      <van-picker
        :title="$t('branchLabel')"
        show-toolbar
        :confirm-button-text="$t('confirm')"
        :cancel-button-text="$t('orderCancel')"
        :columns="optionsbranch"
        @confirm="branchOnConfirm"
        @cancel="branchOnCancel"
      />
    </van-popup>
    <!-- 提交成功的弹窗 -->
    <van-popup
      v-model="showSucess"
      round
      :closeable="true"
      @click-close-icon="handleClosePopup"
      :style="{ height: '40%', width: '70%' }"
    >
      <div class="popup-main">
        <img src="../../assets/imgs/pic-succeed.png" alt="" />
        <div class="textplain">{{ $t('submitSuccessTip') }}</div>
        <div class="timeBack">{{ $t('secondsBack', [countDown]) }}</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fieldValue: "",
      typeId: "",
      typeShow: false,
      optionsType: [],
      typeList: [],
      cascaderValue: "",
      abnormalList: [],
      shopList: [],
      branchId: "",
      checked: [],
      branchValue: "",
      optionsbranch: [],
      branchShow: false,
      problemVal: "",
      menuShow: false,
      phoneVal: "",
      studentId: "",
      showSucess: false,
      countDown: 5,
      fileList: [],
      imageFiles: [],
      backCount: true,
      language: ''
    };
  },
  mounted() {
    let roles = JSON.parse(localStorage.getItem("customerInfoList"));
    this.language = localStorage.getItem('language');
    this.phoneVal = roles && roles[0].phone;
    this.studentId = roles && roles[0].memberNo;
    this.getFeedTypeList();
    this.getShopList();
    // this.getUserPhone();
    setTimeout(() => {
      this.fieldValue = this.optionsType[0];
      this.typeList.map((item) => {
        if (item.name == this.fieldValue) {
          this.typeId = item.id;
          this.abnormalList = item.items;
        }
      });

      this.branchValue = this.optionsbranch[0];
      this.shopList.map((item) => {
        if ((this.language == 'CN' ? item.branchName : item.branchNameEn) == this.branchValue) {
          this.branchId = item.id;
        }
      });
    }, 500);
  },
  methods: {
    //获取意见类型下拉列表
    getFeedTypeList() {
      let shopId = this.$route.query.shopId;
      this.$authAjax
        .post(`/api/wxapp/feedback/type/drop/list/${shopId}`)
        .then((res) => {
          let { data } = res.data;
          this.typeList = data;
          data.map((item) => {
            this.optionsType.push(item.name);
          });
        });
    },
    //获取用户手机号
    getUserPhone() {
      let customerId = this.$route.query.customerId;
      this.$authAjax
        .post(`/api/wxapp/feedback/phone/check/${customerId}`)
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.phoneVal = res.data.data.phone;
          }
        });
    },
    handleChangeType() {
      this.checked = [];
      console.log(this.checked);
    },
    //意见类型弹窗事件
    onConfirm(value, index) {
      this.typeList.map((item) => {
        if (item.name == value) {
          this.typeId = item.id;
          this.abnormalList = item.items;
        }
      });
      this.fieldValue = value;
      this.typeShow = false;
    },
    onCancel() {
      this.typeShow = false;
    },
    //多选或单选
    changeChecked(val) {
      console.log(val);
    },
    //获取分店列表
    getShopList() {
      let shopId = this.$route.query.shopId;
      this.$authAjax
        .post(`/api/wxapp/feedback/branch/list/${shopId}`)
        .then((res) => {
          let { data } = res.data;
          // data.unshift({
          //   branchName: "不清楚分店",
          //   id: "",
          // });
          if (res.data.code == 200) {
            this.shopList = data;
            data.map((item) => {
              this.optionsbranch.push(this.language == 'CN' ? item.branchName : item.branchNameEn);
            });
          } else {
            this.$toast(res.data.message);
          }
        });
    },
    //选择档口分店弹窗
    branchOnConfirm(value, index) {
      this.shopList.map((item) => {
        if ((this.language == 'CN' ? item.branchName : item.branchNameEn) == value) {
          this.branchId = item.id;
        }
      });
      this.branchValue = value;
      this.branchShow = false;
    },
    branchOnCancel() {
      this.branchShow = false;
    },
    afterRead(file) {
      console.log(file.file);
      this.imageFiles.push(file.file);
    },
    deleteFile(file, detail) {
      this.fileList.splice(detail.index, 1);
      this.imageFiles.splice(detail.index, 1);
    },
    //提交
    handleSubmitFeed() {
      if (this.branchValue == "") {
        return this.$toast(this.$t('noBranchTips'));
      }
      this.$toast.loading({
        message: this.language == 'CN' ? "提交中..." : 'submitting...',
        forbidClick: true,
        loadingType: "spinner",
      });
      let formData = new FormData();
      formData.append("shopId", this.$route.query.shopId);
      formData.append("branchId", this.branchId);
      formData.append("typeId", this.typeId);
      for (let i = 0; i < this.checked.length; i++) {
        formData.append(`typeItems`, this.checked[i]);
      }
      formData.append("content", this.problemVal);
      formData.append("hasPic", this.imageFiles.length > 0 ? true : false);
      formData.append("customerId", this.$route.query.customerId);
      formData.append("phone", this.phoneVal);
      formData.append("uniqueCode", this.studentId);
      for (let j = 0; j < this.imageFiles.length; j++) {
        formData.append(`imageFiles`, this.imageFiles[j]);
      }

      console.log(formData, "formData");
      this.$authAjax
        .post("/api/wxapp/feedback/mini/program/add", formData)
        .then((res) => {
          if (res.data.code == 200) {
            this.$toast.clear();
            this.showSucess = true;
            let timeDown = setInterval(() => {
              this.countDown--;
              if (this.countDown == 0 && this.backCount) {
                this.showSucess = false;
                clearInterval(timeDown);
                this.$router.back();
              }
            }, 1000);
          } else {
            this.$toast(res.data.message);
          }
        });
    },
    handleClosePopup() {
      this.backCount = false;
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped>
@function toVw($px) {
  @return ($px / 375) * 100vw;
}
@function toVh($px) {
  @return ($px / 667) * 100vh;
}
.form-main {
  width: 100vw;
  height: 100%;
  overflow: auto;
  // padding: toVh(16) toVw(16);
  box-sizing: border-box;
  background: #ffffff;
  ::v-deep .van-cell__title {
    font-size: toVw(14);
    font-weight: 550;
    color: #202020;
  }
  ::v-deep .van-field__control {
    font-size: toVw(15);
    font-weight: 400;
    color: #202020;
  }
  .borderTop {
    border-top: 1px solid #fcf9f9;
  }
  .type-problem {
    width: toVw(375);
    min-height: toVh(160);
    background: #ffffff;
    box-sizing: border-box;
    .heatel-item {
      margin-bottom: toVh(8);
      line-height: toVh(31);
      margin-top: toVh(14);
      display: flex;
      align-items: center;
      margin-left: toVw(142);
      .item-text {
        min-width: toVw(150);
        font-size: toVw(15);
        font-weight: 400;
        line-height: toVh(17);
        color: #606060;
        margin-left: toVw(8);
      }
    }
  }
  .uploadImg {
    width: toVw(374);
    min-height: toVh(171);
    background: #ffffff;
    padding: toVh(16) toVw(16);
    box-sizing: border-box;
    .title {
      font-size: toVw(17);
      font-weight: 550;
      color: #202020;
      line-height: toVh(19);
    }
    .img-main {
      display: flex;
      align-items: center;
      margin-top: toVh(10);
      .yet-upload {
        width: toVw(96);
        height: toVh(96);
        margin-top: toVh(16);
        margin-right: toVw(5);
        img {
          width: 100%;
          height: 100%;
        }
      }
      .area {
        width: toVw(96);
        height: toVh(96);
        background: #f7f8fa;
        margin-top: toVh(16);
        text-align: center;
        line-height: toVh(96);
        img {
          width: toVw(26);
          height: toVh(26);
        }
      }
    }
  }
  .handle_none {
    display: none;
  }
  .submit {
    width: toVw(343);
    height: toVh(52);
    background: linear-gradient(134deg, #4bd891 0%, #05a856 100%);
    border-radius: 27px 27px 27px 27px;
    font-size: toVw(17);
    font-weight: 400;
    color: #ffffff;
    line-height: toVh(52);
    text-align: center;
    margin: toVh(16) auto toVh(24) auto;
  }
  .popup-main {
    margin-top: toVh(32);
    text-align: center;
    img {
      width: toVw(140);
      height: toVh(140);
    }
    .textplain {
      font-size: toVw(17);
      font-weight: bold;
      color: #3cbe7e;
      line-height: toVh(20);
      margin-top: toVh(20);
    }
    .timeBack {
      font-size: toVw(12);
      font-weight: 400;
      color: #909090;
      line-height: toVh(14);
      margin-top: toVh(10);
    }
  }
}
</style>
